<template>
  <div id="ColocationList">
    <SolutionsList
      :list="list"
      :view-loader="viewLoader"
      :view-error="viewError"
      :no-data-message="$t('colocation.noData')"
      :colspan="6"
    >
      <template #table-headers>
        <th v-if="!$IsMobile()">{{ $t("colocation.detail.dc") }}</th>
        <th>{{ $t("colocation.list.room") }}</th>
        <th>{{ $t("colocation.list.rack") }}</th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
      </template>
      <template #mobile-row="{ item }">
        <MobileCard
          :titles="['address', 'name']"
          :item="item"
          translation-path="colocation.solutions"
        >
          <template #url-label>
            <router-link
              :to="`/${$t('nav.colocationDetailsUrl', {
                item_id: item.id,
              })}`"
            >
              <div class="cdlButton">
                <span>
                  {{ $t("lines.details") }}
                </span>
              </div>
            </router-link>
          </template>
        </MobileCard>
      </template>
      <template #desktop-row="{ item }">
        <tr>
          <td>
            <span>{{ item.building }}</span>
          </td>
          <td>
            <span>{{ item.datacenter + " - " + item.address }}</span>
          </td>
          <td>
            <span>{{ item.name }}</span>
          </td>
          <td>
            <router-link
              :to="`/${$t('nav.colocationDetailsUrl', {
                item_id: item.id,
              })}`"
            >
              <div class="cdlButton">{{ $t("tickets.details") }}</div>
            </router-link>
          </td>
          <td>
            <div
              style="
                display: inline-flex;
                justify-content: flex-end;
                width: 100%;
              "
            >
              <HelpRequestBtn
                v-if="ctrlPerms(['incident_lista'])"
                :component-name="'IncidentFormColocation'"
                :asset-type="'colocation'"
                :item-id="item.id"
                :icon="'warning'"
                :label="$t('help.incident.formTitle')"
              />
              <HelpRequestBtn
                v-if="ctrlPerms(['change_request_list'])"
                :component-name="'ChangeRequestFormColocation'"
                :asset-type="'colocation'"
                :item-id="item.id"
                :icon="'person'"
                :label="$t('help.changeRequest.formTitle')"
              />
              <HelpRequestBtn
                v-if="ctrlPerms(['change_request_list']) && false"
                :url="`/solutions/${$t('nav.techSupportUrl', {
                  item_id: item.id,
                  asset_type: 'colocation',
                })}`"
                :icon="'settings'"
                :label="$t('help.techSupport.formTitle')"
              />
            </div>
          </td>
        </tr>
      </template>
    </SolutionsList>
  </div>
</template>

<script>
import SolutionsList from "@/components/Solutions/SolutionsList.vue";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn";
import MobileCard from "@/components/Cards/MobileCard.vue";

export default {
  name: "ColocationList",
  components: {
    MobileCard,
    SolutionsList,
    HelpRequestBtn,
  },
  props: {
    list: Array,
    viewLoader: Boolean,
    viewError: Boolean,
  },
  methods: {
    ctrlPerms(perms) {
      return this.$ctrlPermissions(perms);
    },
  },
};
</script>
